import React from 'react';
import styles from './InfoCard.css';

function InfoCard(props) {
  const { title, icon, children, subTitle } = props;
  return (
    <div className={styles.wrapper}>
      <div className={styles['icon-wrapper']}>{icon}</div>
      <p className={styles.title}>{title}</p>
      {subTitle && <p className={styles.subtitle}>{subTitle}</p>}
      <div className={styles.line} />
      <div className={styles['content-info']}>{children}</div>
    </div>
  );
}

export default InfoCard;
